import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import type { AnyRoute } from "@tanstack/react-router";

export const createAuthzRoutes = (parent: AnyRoute) => [
  createRoute({
    getParentRoute: () => parent,
    path: "/authz/permission",
    component: lazyRouteComponent(() => import("pages/authz/permission")),
  }),
  createRoute({
    getParentRoute: () => parent,
    path: "/authz/role",
    component: lazyRouteComponent(() => import("pages/authz/role")),
  }),
];
